/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { Field } from 'Util/Query';

/** @namespace Pwa/Query/VfitsVehiclesByProduct/Query/VfitsVehiclesByProductQuery */
export class VfitsVehiclesByProductQuery {
    getVehiclesByProductQuery(sku) {
        return new Field('vehiclesByProduct')
            .addArgument('sku', 'String!', sku)
            .addFieldList(this._getVehicleFields());
    }

    _getVehicleFields() {
        return [
            'make',
            'model',
            'option',
            'years',
            'yearsGrouped'
        ];
    }
}

export default new VfitsVehiclesByProductQuery();
